const getQuerystring = (locationSearch, name) => {
  const queryString = new URLSearchParams(locationSearch);
  return queryString.get(name);
};

export {
  getQuerystring,
};